<template>
    <div>
        <Header></Header>
        <div class="registration">
            <b-container class="registration-container">
                <b-row> 
                    <b-col
                        cols='11'
                        class="registr-head mx-auto"
                    >
                        <strong>{{'registrationUserHeader' | localize}}</strong>
                    </b-col>
                </b-row>
                <b-row>
                    <UserRegistrForm v-if="selected"></UserRegistrForm>
                    <LegalUserRegistrForm v-if="!selected"></LegalUserRegistrForm>
                </b-row>
            </b-container>        
        </div>
    </div>
</template>
<script>
import Header from '../components/Header'
import UserRegistrForm from '../components/registration/UserRegistrForm.vue'
//import LegalUserRegistrForm from '../components/registration/LegalUserRegistrForm.vue'
export default {
    data: () => ({
        selected: true,
        options: [
            { value: true, text: 'Физическое лицо' },
            //{ value: false, text: 'Юридическое лицо' },
        ],
        registr: true
    }),
    components: { UserRegistrForm, Header}
}
</script>
